export class CreateCalibration {
  deliveryDeviceId: number;
  procedureId: number;
  personId: number;
  calibrationDate: Date;
  status: number;
  environmentalConditionId: number;
  accreditationOrganization: number;
  isPlace: boolean;
  acceptanceDate?: Date;
  turkakCalibrationId?: string;
  placeAddress: string;
  measurementFile: File;
  saveFilePath: string;
  visualAndFunctional: string;
  createCalibrationReferenceDevices: {
    deviceId: number;
    calibrationId?: number;  // Opsiyonel hale getirildi.
  }[];
}

/*
{
  "calibrationNo": "string",
  "deliveryDeviceId": 0,
  "procedureId": 0,
  "personId": 0,
  "calibrationDate": "2025-02-17T11:28:23.925Z",
  "status": 0,
  "environmentalCondition": "string",
  "accreditationOrganization": 0
}
*/